import {
  FocusContext,
  useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'
import React, { useMemo } from 'react'
import { platformTransitionStyle, throttle } from '../../../../shared/helpers'
import CollectionsSet from '../../components/CollectionsSet'
import LogoHeaderTS from '../../components/LogoHeader'
import { ContentDetails, ContentImage } from '../../components/VideoDetail'
import { useAppSelector } from '../../hooks/useStore'
import ErrorModalProvider from './context/ErrorModalProvider'

const COLLECTIONS_TOP_OFFSET = 120

function VideoDetailContainer() {
  const { ref, focusKey } = useFocusable({
    focusKey: 'VIDEO_DETAIL_SCREEN_CONTAINER',
  })

  const [translateY, setTranslateY] = React.useState(0)
  const { collections } = useAppSelector((state) => state.content.videoDetails)

  const onContentDetailsFocus = () => {
    setTranslateY(0)
  }

  const handleCollectionsFocus = (layout) => {
    setTranslateY(-(layout.top - COLLECTIONS_TOP_OFFSET))
  }

  const handleWheel = useMemo(
    () =>
      throttle((event: React.WheelEvent<HTMLDivElement>) => {
        const deltaY = event.deltaY
        if (deltaY > 0) {
          setTranslateY((prev) =>
            Math.max(-ref.current.scrollHeight + 650, prev - 650)
          )
        } else if (deltaY < 0) {
          setTranslateY((prev) => Math.min(0, prev + 650))
        }
      }, 600),
    []
  )

  return (
    <FocusContext.Provider value={focusKey}>
      <ErrorModalProvider>
        <div
          ref={ref}
          className="video-detail-screen"
          style={{
            transition: platformTransitionStyle('transform 500ms ease-in-out'),
            transform: `translateY(${translateY}px)`,
          }}
          onWheel={handleWheel}
        >
          <div className="video-detail-screen__header">
            <LogoHeaderTS />
            <ContentImage />
            <ContentDetails onFocus={onContentDetailsFocus} />
          </div>
          <CollectionsSet
            hasHeaderComponent
            collections={collections}
            className="video-detail-screen__collections"
            onFocus={handleCollectionsFocus}
            handelWheelExternally
          />
        </div>
      </ErrorModalProvider>
    </FocusContext.Provider>
  )
}

export default VideoDetailContainer
